import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})

/*
  * @author Opeoluwa
   * @dateCreated 4th Aug 2023
 * @description This guard ensures that only authenticated users can access protected routes.
 * If the user is not authenticated, it redirects them to the login page.
 * @modifiedBy - None
 * @dateModified - None
 * @reasonForModification - None
 */
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthenticationService, private router: Router) {}

  
  /*
     * @author Opeoluwa
   * @dateCreated 4th Aug 2023
   * @description The function determines whether a user is authenticated or not.
   * If authenticated, it allows access to the requested route. Otherwise, it redirects to the login page.
   * @param next - The next ActivatedRouteSnapshot.
   * @param state - The current RouterStateSnapshot.
   * @returns A boolean value indicating whether the user is authenticated or not.
   * @modifiedBy - None
   * @dateModified- None
   * @reasonForModification - None
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('AuthGuard: canActivate is called');
    const isAuthenticated = this.authService.isAuthenticated();
    console.log('AuthGuard: isAuthenticated', isAuthenticated);
  
    if (isAuthenticated) {
      console.log('User is authenticated. Proceeding to the route.');
      return true;
    } else {
      console.log('User is not authenticated. Redirecting to login page.');
      this.router.navigate(['/home-page/login']);
      return false;
    }
  }
  
}